import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Form, Modal } from 'react-bootstrap';
import { updateSubjectRate } from '@app/services/subject';

const UpdateSubjectRateModal = (props) => {

    const [isLoading, setLoading] = useState(false);

    const updateSubjectRateAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateSubjectRate(payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.getAllSubjectsAPI();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.response?.message || 'Failed');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            id: props?.subject?.id ?? '',
            subject_rate: props?.subject?.rate ?? 0,
        },
        validationSchema: Yup.object({
            subject_rate: Yup.number().required('Please enter rate').positive('Rate must be a positive number'),
            // .max(10000, 'Rate must be less than or equal to 10,000'),
        }),
        onSubmit: (values) => {
            updateSubjectRateAPI(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose} size="sm">
            <Modal.Header closeButton>
                <Modal.Title>Update Subject Rate</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <dt>Subject Name </dt>
                                <dd>{ props?.subject?.name } </dd>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Rate Per Student<span className="required">*</span></label>
                                <div className='input-group'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">£</span>
                                    </div>
                                    <Form.Control 
                                        className='col-sm-9'
                                        type="number" 
                                        name="subject_rate" 
                                        id="subject_rate" 
                                        placeholder="Enter subject rate" 
                                        value={values.subject_rate}
                                        onChange={handleChange}
                                        onWheel={ (e) => e.currentTarget.blur() }
                                    />
                                </div>
                                {(touched.subject_rate && errors.subject_rate) && (
                                    <div className="text-danger">
                                        {errors.subject_rate}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdateSubjectRateModal;